import moment from 'moment';
import { validStatus } from '.';
import {
  DISPLAY_DATE, DEFAULT_ARRIVAL_WINDOW_HOURS,
  MOMENT_TIME, DISPLAY_TIME, OTHER_DATE, RAILS_DATE,
} from 'config/constants';

/**
 * Parses a date string strictly using moment.js and provided formats.
 * @param {string} value - The date string to parse.
 * @param {string|string[]} formats - The format(s) to use for parsing.
 * @returns {moment.Moment} A moment object representing the parsed date.
 */
export const parseDateStrict = (value, formats) =>
  moment(value, formats, true);

export const handleDateSave = (stringValue) => {
  if (!stringValue) return stringValue;
  const date = moment(stringValue, [OTHER_DATE, DISPLAY_DATE]).format(RAILS_DATE);
  if (date === 'Invalid Date') return 'Invalid Date';
  return date;
};

const getMomentWithFormat = (utcDate, format) => moment(utcDate).local().format(format).toString();

export const getLocalDate = utcDate => getMomentWithFormat(utcDate, 'dddd, MM/DD/YYYY, h:mm:ss a');

export const getMinLocalDate = utcDate => getMomentWithFormat(utcDate, 'MM/DD/YYYY, h:mm a');

export const getSimpleLocalDate = utcDate => getMomentWithFormat(utcDate, 'MM/DD/YYYY');

export const isValidDate = utcDate => moment(utcDate, moment.ISO_8601, true).isValid();

export const isOverdue = date => moment(date).isSameOrBefore(moment().endOf('day'));

export const formatTime = date => moment(date, 'HH:mm').format('hh:mma');

export const momentDiff = (date1, date2, unit = 'milliseconds') => moment(date1).diff(moment(date2), unit);

export const momentDiffDuration = (date1, date2, units = { diff: 'milliseconds', duration: 'milliseconds' }) =>
  moment.duration(momentDiff(date1, date2, units.diff), units.duration);

export const getDuration = ({ status, created_at_default, status_began_at }, defaultValue = { yes: false, val: '' }) => {
  let duration = defaultValue.val;
  if (defaultValue.yes && (!created_at_default || !status_began_at)) return duration;
  if (validStatus(status, ['completed', 'canceled'])) duration = momentDiffDuration(status_began_at, created_at_default) || duration;
  else duration = momentDiffDuration(moment(), created_at_default) || duration;
  return duration;
};

export const getDayCount = (startDate, endDate) => momentDiff(endDate, startDate, 'days') + 1;

export const getDaysStringFromDuration = (duration, defaultValue = '') => {
  if (!duration || !duration.isValid()) return defaultValue;
  const durationInDays = Math.round(duration.asDays()) || false;
  return durationInDays ? `${durationInDays} ${durationInDays === 1 ? 'day' : 'days'}` : defaultValue;
};

export const getDisplayDateFromString = (date, format) => moment(date, format).format(DISPLAY_DATE);

export const getTimeMoment = time => moment(time, MOMENT_TIME);

export const getDisplayTime = time => getTimeMoment(time).format(DISPLAY_TIME);

export const getEndTimeString = (startTime, isDelivery = false) => {
  let endMoment = null;
  const startMoment = getTimeMoment(startTime);
  const noonMoment = getTimeMoment('13:00');
  const eodMoment = getTimeMoment('18:00');
  if (isDelivery) endMoment = startMoment.isBefore(noonMoment) ? noonMoment : eodMoment;
  else endMoment = startMoment.add(DEFAULT_ARRIVAL_WINDOW_HOURS.default, 'h');
  return endMoment.format(MOMENT_TIME);
};

export const getYear = () => moment().format('YYYY');

export const getThanksgiving = () => {
  const result = moment(`11/01/${getYear()}`, 'MM/DD/YYYY');
  let numThursdays = 0;
  while (numThursdays < 4) {
    const currDay = result.day();
    if (currDay === 4) numThursdays += 1;
    if (numThursdays < 4) result.add(1, 'day');
  }
  return result.format('MM/DD/YYYY');
};

export const getChristmasEve = () => moment(`12/24/${getYear()}`, 'MM/DD/YYYY').format('MM/DD/YYYY');

export const getChristmasDay = () => moment(`12/25/${getYear()}`, 'MM/DD/YYYY').format('MM/DD/YYYY');

export const sortApptsByDate = (appts, byEndDate = false) => appts.sort((a, b) =>
  moment(a[`${byEndDate ? 'end' : 'start'}_date`], 'YYYYMMDD').diff(moment(b.start_date, 'YYYYMMDD')));

export const filterApptsByTodayOrLater = (appts, byEndDate = false) => appts.filter(a =>
  moment(a[`${byEndDate ? 'end' : 'start'}_date`], 'YYYYMMDD').isSameOrAfter(moment(new Date(), 'YYYYMMDD')));



// WEBPACK FOOTER //
// ./client/app/utils/dateUtils.js